import { post } from '../api-service'

export interface EmailCaptureParams {
  email: string
  event_name?: string
  page_source?: string
  campaign?: string
  location?: string
  content_type?: string
  slug?: string
  category?: string
}

export const trackEmailCapture = async (payload: EmailCaptureParams) =>
  post('/api/v3/growth/email-capture', payload)
